import { render } from "./ModelConfigPanel.vue?vue&type=template&id=6f5e942a&scoped=true"
import script from "./ModelConfigPanel.vue?vue&type=script&lang=js"
export * from "./ModelConfigPanel.vue?vue&type=script&lang=js"

import "./ModelConfigPanel.vue?vue&type=style&index=0&id=6f5e942a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5e942a"]])

export default __exports__